<template>
  <RedirectUrl />
</template>

<script>
import appConfig from '@/app.config'
import RedirectUrl from '../../../components/dadban/RedirectUrl.vue'

export default {
  components: { RedirectUrl },
  page: {
    title: 'مدیریت بسته',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-redirect',
}
</script>

<style></style>
